/* eslint-disable max-len */
import React from 'react';
import { IconProps } from '../IconProps';
import { SVGWrapper } from '../SVGWrapper';

const InsuraceNavigationIcon: React.FC<IconProps> = ({ aspect, color, style = {} }) => (
    <SVGWrapper aspect={aspect} color={color} style={style}>
        <path
            d="M23,11h-4l0-8.2c0-0.7-0.6-1.3-1.3-1.3H2.4C1.6,1.5,1,2,1,2.7v19.2c0,0.7,0.6,1.3,1.3,1.3l18.8,0
	c1.2,0,2.1-0.9,2.1-2.1v-9.8C23.3,11.1,23.1,11,23,11z"
        />
        <path d="M20.4,23.2c-0.8,0-1.5-0.7-1.5-1.5l0-10.7" />
        <path
            d="M15.1,14.4c0,0.3-0.2,0.5-0.5,0.5H5.3c-0.2,0-0.5-0.2-0.5-0.5V4.9c0-0.3,0.2-0.5,0.5-0.5h9.4
	c0.2,0,0.5,0.2,0.5,0.5V14.4z"
        />
        <line x1="4.9" y1="19.3" x2="15.1" y2="19.3" />
    </SVGWrapper>
);

export default InsuraceNavigationIcon;
